__turbopack_context__.v({
  "label": "KcsOMG_label",
  "wrapper": "KcsOMG_wrapper",
});
